import * as actionTypes from './actionTypes';

interface State {
  data: any;
  confirm: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  confirm: {},
  isFetching: false,
  error: false
}

export const payment = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.SEND_DATA_PAYMENT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.SEND_DATA_PAYMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.SEND_DATA_PAYMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_DATA_PAYMENT_CONFIRM:
      return {
        ...state,
        isFetching: false,
        error: false,
        confirm: action.data
      }
    default:
      return state;
  }
}
